export const postActionPopups = {
  ACTIONS: 'ACTIONS',
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE'
};

export default postActionPopups;
